import Titles from '../components/Titles/Titles';
import PrivacyTermsComponent from '../components/PrivacyTerms/PrivacyTermsComponent';
import SEO from '../components/SEO/SEO';
import { usePageSEO } from '../hooks/usePageSEO';

const PrivacyPolicy = () => {
    const seo = usePageSEO('privacyPolicy');

    return (
        <>
            <SEO
                title={seo.title}
                description={seo.description}
                keywords={seo.keywords}
                type={seo.type}
                noIndex={seo.noIndex}
                noFollow={seo.noFollow}
            />
            <Titles pageType="privacy" additionalElementClassName="privacy__date"/>
            <PrivacyTermsComponent type="privacy"/>
        </>
    );
};

export default PrivacyPolicy;